<template>
  <navbar
    position="fixed"
    :transparent="transparent"
    :color-on-scroll="colorOnScroll"
    menu-classes="ml-auto"
  >
    <template slot-scope="{toggle, isToggled}">
      <router-link v-popover:popover1 class="navbar-brand" to="/homeV4">
        <img class="img logo" src="img/logo-osapm.png" />
      </router-link>

      <!-- popover popup sobre el logo -->
      <!-- <el-popover
        ref="popover1"
        popper-class="popover"
        placement="bottom"
        width="200"
        trigger="hover"
      >
        <div class="popover-body">{{ constants.appSubtitle }}</div>
      </el-popover> -->
    </template>
    <template slot="navbar-menu">
      <!--     *********    MENU GENERAL       *********      -->
      <!-- <drop-down tag="li" title="Menu" icon="now-ui-icons design_app" class="nav-item">
        <nav-link to="/cobertura">
          <i class="now-ui-icons design_app"></i> Planes de cobertura
        </nav-link>

        <nav-link to="/cartilla">
          <i class="now-ui-icons design_app"></i> Prestadores principales de cartilla
        </nav-link>

        <nav-link to="/contacto">
          <i class="now-ui-icons design_app"></i>Información de contacto
        </nav-link>

        <nav-link to="/institucional">
          <i class="now-ui-icons design_app"></i>Institucional
        </nav-link>

        <nav-link to="/oficinas">
          <i class="now-ui-icons design_app"></i>Oficinas
        </nav-link>

        <nav-link to="/telefonos">
          <i class="now-ui-icons design_app"></i>Telefonos útiles
        </nav-link>

        <nav-link to="/formularios">
          <i class="now-ui-icons design_app"></i>Descargar formularios
        </nav-link>

        <nav-link to="/faq">
          <i class="now-ui-icons design_app"></i>Preguntas frecuentes
        </nav-link>

        <nav-link to="/noticias">
          <i class="now-ui-icons design_app"></i>Novedades y noticias
        </nav-link>

        <nav-link to="/quieroAfiliarme">
          <i class="now-ui-icons design_app"></i>Quiero Afiliarme
        </nav-link>
      </drop-down>-->
      <!--     *********    END MENU GENERAL      *********      -->
      <!--     *********    INICIO      *********      -->
      <!--
       <li tag="nav-item" title="inicio" icon="now-ui-icons files_paper" to class="nav-item">
        <a class="nav-link" href="#/home">
          <p>
            <i class="now-ui-icons business_bank"></i>INICIO
          </p>
        </a>
      </li>
      -->
      <a class="nav-link" href="#/homeV4"  @click="closeMenu">
        <p>Inicio</p>
      </a>
     
      <!-- <drop-down tag="li" title="Inicio" icon="now-ui-icons files_paper" class="nav-item">
        <a href="#/home" class="dropdown-item">
          <i class="now-ui-icons arrows-1_cloud-download-93"></i> Inicio
        </a>
        <a href="#/homeV1" class="dropdown-item">
          <i class="now-ui-icons arrows-1_cloud-download-93"></i> Inicio V1
        </a>
        <a href="#/homeV2" class="dropdown-item">
          <i class="now-ui-icons arrows-1_cloud-download-93"></i> Inicio V2
        </a>
        <a href="#/homeV3" class="dropdown-item">
          <i class="now-ui-icons arrows-1_cloud-download-93"></i> Inicio V3
        </a>
        <a href="#/homeV4" class="dropdown-item">
          <i class="now-ui-icons arrows-1_cloud-download-93"></i> Inicio V4
        </a>
      </drop-down>-->
      <!--     *********    END INICIO      *********      -->
      <!--     *********    PLANES      *********      -->
      <li tag="nav-item" icon="now-ui-icons files_paper" to class="nav-item">
        <a class="nav-link" href="#/planes"  @click="closeMenu">
          <p>PLANES</p>
        </a>
      </li>
      <!--     *********    END PLANES      *********      -->
      <!--     *********    FORMULARIOS      *********      -->
      <!-- <li tag="nav-item" title="formularios" icon="now-ui-icons files_paper" to="" class="nav-item">
        <a class="nav-link" href="#/formularios">
          <p><i class="now-ui-icons arrows-1_cloud-download-93"></i>FORMULARIOS</p>
        </a>
      </li>-->
     <!-- <drop-down tag="li" title="Formularios" class="nav-item">
        <a href="#/formularios" class="dropdown-item">Salud</a>
        <a href="#/formulariosAfiliacion" class="dropdown-item">Afiliación</a>
      </drop-down>
      -->

      <!--     *********    END FORMULARIOS      *********      -->
      <!--     *********    TRAMITES      *********      -->
     <!-- <li tag="nav-item" title="tramites" icon="now-ui-icons files_paper" to class="nav-item">
        <a class="nav-link" href="#/tramites">
          <p>TRAMITES</p>
        </a>
      </li>
      -->
      <!--     *********    END TRAMITES      *********      -->
      <!--     *********    CONTACTO      *********      -->
      <!-- <li tag="nav-item" title="contacto" icon="now-ui-icons files_paper" to="" class="nav-item">
        <a class="nav-link" href="#/contacto">
          <p><i class="now-ui-icons ui-1_send"></i>CONTACTO</p>
        </a>
      </li>-->
      <!--     *********    TRAMITES      *********      -->
      <li tag="nav-item" to class="nav-item">
        <a class="nav-link" href="#/centroMedicoEcuador"  @click="closeMenu">
          <p>Centro Médico OSAPM</p>
        </a>
      </li>
   <!--  <drop-down tag="li" title="Centro médico Ecuador"  class="nav-item">
        <a href="#/oficinas" class="dropdown-item">Centro médico</a>
        <a href="#/telefonos" class="dropdown-item">Odontología</a>
      </drop-down>
      -->
      <!--     *********    END TRAMITES      *********      -->
      <drop-down tag="li" title="Contacto"  class="nav-item">
        <a href="#/oficinas" class="dropdown-item"  @click="closeMenu" >Seccionales</a>
        <a href="#/telefonos" class="dropdown-item"  @click="closeMenu">Teléfonos Utiles</a>
        <a href="#/contacto" class="dropdown-item"  @click="closeMenu">Contacto</a>
      </drop-down>
      <drop-down tag="li" title="Información"  class="nav-item">
        <a href="#/tramites" class="dropdown-item"  @click="closeMenu">Trámites</a>
        <a href="#/formulariosAfiliacion" class="dropdown-item"  @click="closeMenu">Formulario Afiliación</a>
        <a href="#/formularios" class="dropdown-item"  @click="closeMenu">Formulario de Salud</a>
        <a href="#/formulariosPrestador" class="dropdown-item"  @click="closeMenu">Formularios de Prestador</a>
        <a href="#/faq" class="dropdown-item"  @click="closeMenu">Preguntas frecuentes</a>
        <a href="#/institucional" class="dropdown-item"  @click="closeMenu">Institucional</a>
      </drop-down>
      <!--     *********    END CONTACTO      *********      -->
      <!--     *********    INSTITUCIONAL      *********      -->
      <!--<li tag="nav-item" title="institucional" icon="now-ui-icons files_paper" to class="nav-item">
        <a class="nav-link" href="#/institucional">
          <p>INSTITUCIONAL</p>
        </a>
      </li>
      -->
      <!--     *********    END INSTITUCIONAL      *********      -->

      <!--     *********    INGRESO      *********      -->
      <!-- <li tag="nav-item" title="ingresar" icon="now-ui-icons files_paper" to class="nav-item">
        <a class="nav-link" href="#/login">
          <p>
            <i class="now-ui-icons users_single-02"></i>INGRESAR
          </p>
        </a>
      </li>-->

      <drop-down tag="li" title="Ingresar"  class="nav-item">
        <a href="#/login" class="dropdown-item" target="_blank"  @click="closeMenu">Afiliados</a>
        <a href="#/prestador/login" class="dropdown-item" target="_blank"  @click="closeMenu">Prestadores</a>
      </drop-down>

      <!--     *********    END INGRESO      *********      -->

      <!--     *********    QUIERO AFILIARME      *********      -->
      <li class="nav-item">
        <a class="nav-link btn btn-primary" href="#/afiliarme" style="padding-left:7px;padding-right:7px;">
          <p>Quiero Afiliarme</p>
        </a>
      </li>
      <!--     *********   END QUIERO AFILIARME      *********      -->
    </template>
  </navbar>
</template>

<script>
import { DropDown, NavbarToggleButton, Navbar, NavLink } from "@/components";
import { Popover } from "element-ui";
import $ from "jquery";

export default {
  name: "main-navbar",
  props: {
    transparent: Boolean,
    colorOnScroll: Number
  },
  components: {
    DropDown,
    Navbar,
    NavbarToggleButton,
    NavLink,
    [Popover.name]: Popover
  },
  methods: {
  closeMenu: function() {
     document.body.classList.remove('nav-open');
    document.getElementsByClassName('navbar-toggler')[0].classList.remove('toggled');

  }
}
};


</script>

<style scoped>
.logo {
  height: 40px;
  width: auto;
}
</style>
